import Toast from 'react-native-toast-message';
import { messageFactory, Topic, useDownloadStateStore, } from '@annunciate/core';
import DownloadUtils from '../../DownloadUtils';
import { onSuccessfulDownloadMutateCache } from './onSuccessfulDownloadMutateCache';
const { setDownloadDetails, addTask, removeTask, } = useDownloadStateStore.getState();
export const registerDownloadTaskEventListeners = ({ task, client, }) => {
    addTask(task);
    const [contentId, type] = task.id.split(':');
    const metadata = task.metadata;
    if (type === 'asset') {
        return registerAssetTaskListeners({
            contentId,
            task,
            metadata,
            client,
        });
    }
    else if (type === 'cover') {
        return registerCoverTaskListeners({
            task,
            metadata,
            client,
        });
    }
    else {
        throw new Error('Unknown download task type.');
    }
};
function registerAssetTaskListeners({ contentId, task, metadata, client, }) {
    const { uuid, item, destination } = metadata;
    task
        .begin(({ expectedBytes }) => {
        messageFactory(Topic.CONTENT_DOWNLOAD_STARTED, {
            item: {
                type: 'content',
                id: item.id,
            },
        });
        const megabytes = expectedBytes / 1000000;
        if (megabytes > 500) {
            const gb = megabytes / 1000;
            Toast.show({
                type: 'info',
                text1: 'Download in Progress',
                text2: `This download is large (${gb.toFixed(2)} GB). Please be patient.`,
            });
        }
    })
        .progress(({ bytesDownloaded, bytesTotal }) => {
        setDownloadDetails(contentId, {
            progress: (bytesDownloaded / bytesTotal),
            contentLength: bytesTotal,
            bytesWritten: bytesDownloaded,
        });
    });
    return new Promise((res, rej) => {
        task
            .done(({ bytesDownloaded, bytesTotal }) => {
            onSuccessfulDownloadMutateCache({
                client,
                items: [item],
                uuid,
                assetDestination: destination,
            });
            setDownloadDetails(contentId, {
                progress: 1,
                contentLength: bytesTotal,
                bytesWritten: bytesDownloaded,
            });
            removeTask(task);
            messageFactory(Topic.CONTENT_DOWNLOAD_COMPLETED, {
                item: {
                    type: 'content',
                    id: item.id,
                },
            });
            DownloadUtils.completeHandler(task.id);
            res(task.id);
        })
            .error((error) => {
            removeTask(task);
            rej(error);
        });
    });
}
function registerCoverTaskListeners({ task, metadata, client, }) {
    const { uuid, item, destination } = metadata;
    return new Promise((res) => {
        task
            .done(() => {
            onSuccessfulDownloadMutateCache({
                client,
                items: [item],
                uuid,
                coverDestination: destination,
            });
            removeTask(task);
            DownloadUtils.completeHandler(task.id);
            res(task.id);
        })
            .error((err) => {
            console.error('Error downloading cover', task.id, err);
            removeTask(task);
            res(task.id);
        });
    });
}
//# sourceMappingURL=registerDownloadTaskEventListeners.js.map